import React, { useEffect } from "react";
import {
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Separator } from "./ui/separator";
import { CustomDatePicker } from "./custom-date-picker";
import { cn } from "@/lib/utils";
import { CustomModal } from "./custom-modal";
import { Loader2 } from "lucide-react";
import { formatType } from "@/lib/helper";
import { HiOutlineDownload } from "react-icons/hi";
import { getDownload } from "@/services/Users.service";
import { useLocation } from "react-router-dom";
import { ToastMessage, type } from "@/lib/toastr";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const ExportFilterAction = () => {
  const [dateFrom, setDateFrom] = React.useState<Date>();
  const [dateTo, setDateTo] = React.useState<Date>();
  const [selected, setSelected] = React.useState('')
  const [dateFromFormat, setDateFromFormat] = React.useState("");
  const [dateToFormat, setDateToFormat] = React.useState("");
  const [status, setStatus] = React.useState('');
  const [emailVerified, setEmailVerified] = React.useState("");
  const [kycStatus, setKYCStatus] = React.useState('');
  const [downloadLoading, setDownloadLoading] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation()?.pathname

  useEffect(() => {
    if (dateFrom !== undefined) {
      setDateFromFormat(formatType(dateFrom));
    }
    if (dateTo !== undefined) {
      setDateToFormat(formatType(dateTo));
    }
  }, [dateTo, dateFrom]);
  const getToday = () => {
    const currentDate = new Date();
    setDateFrom(currentDate);
    setDateTo(currentDate);
  };
  const get7days = () => {
    const currentDate = new Date();
    const prev = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
    setDateTo(currentDate);
    setDateFrom(prev);
  };
  const get1Month = () => {
    const currentDate = new Date();
    const prev = new Date();
    prev.setMonth(prev.getMonth() - 1);
    setDateFrom(prev);
    setDateTo(currentDate);
  };
  const get6Month = () => {
    const currentDate = new Date();
    const prev = new Date();
    prev.setMonth(prev.getMonth() - 6);
    setDateFrom(prev);
    setDateTo(currentDate);
  };
  const get1Year = () => {
    const currentDate = new Date();
    const prev = new Date();
    prev.setFullYear(prev.getFullYear() - 1);
    setDateFrom(prev);
    setDateTo(currentDate);
  };

  const downloadUrl = location?.includes('transactions') ? 'transactions' : 'business/customer'
  const downloadName = location?.includes('transactions') ? 'transactions-report' : "customer-report"


  const download = () => {
    setDownloadLoading(true);
    getDownload(dateToFormat, dateFromFormat, downloadUrl, status, emailVerified, kycStatus)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `${downloadName}.${"csv"}`);
        document.body.appendChild(link);
        link.click();
        setDownloadLoading(false);
        setDateFrom(undefined)
        setDateTo(undefined)
        setEmailVerified("")
        setKYCStatus("")
        setStatus("")
        setIsOpen(false)
        ToastMessage(type.SUCCESS, "Download successful");
      })
      .catch((error) => {
        setDownloadLoading(false);

        ToastMessage(type.ERROR, error?.response?.data?.message);

        if (error.response) {
        } else if (error.request) {
        } else {
        }
      });
  };

  // console.log(dateFrom);

  return (
    <CustomModal
      button={
        <Button
          variant="outline"
          className="border-off-white text-primary0"
          onClick={() => setIsOpen(true)}
        >
          <HiOutlineDownload />
          Export
        </Button>

      }
      open={isOpen}
      onOpenChange={(e: any) => {
        setIsOpen(e)
        setDateFrom(undefined)
        setDateTo(undefined)
        setEmailVerified("")
        setKYCStatus("")
        setStatus("")
      }}
    >
      <DialogHeader className="px-5 py-4 border-b-[1px] flex flex-row w-xs">
        <DialogTitle>Export</DialogTitle>
      </DialogHeader>

      <div className="flex flex-col items-start gap-6 px-5 py-4">
        {location?.includes('transactions') &&
          <>
            <div className="flex flex-col gap-2">
              <Label className="text-xs">Select Range</Label>
              <div className="flex flex-wrap gap-2">
                <Button
                  type="button"
                  // key={i}
                  className={cn(
                    "rounded-3xl text-xs h-6 p-[10px]",
                    selected === "Today"
                      ? "bg-primary-0 hover:bg-primary-0 border-0"
                      : "bg-transparent hover:bg-transparent"
                  )}
                  variant="outline"
                  onClick={() => {
                    getToday();
                    setSelected("Today");
                    // selectDateFromChange("");
                    // selectDateToChange("");
                  }}
                >
                  Today
                </Button>
                <Button
                  type="button"
                  className={cn(
                    "rounded-3xl text-xs h-6 p-[10px]",
                    selected === "7 days"
                      ? "bg-primary-0 hover:bg-primary-0 border-0"
                      : "bg-transparent hover:bg-transparent"
                  )}
                  variant="outline"
                  onClick={() => {
                    setSelected("7 days");
                    get7days();
                    // selectDateFromChange("");
                    // selectDateToChange("");
                  }}
                >
                  7 days
                </Button>
                <Button
                  type="button"
                  className={cn(
                    "rounded-3xl text-xs h-6 p-[10px]",
                    selected === "1 month"
                      ? "bg-primary-0 hover:bg-primary-0 border-0"
                      : "bg-transparent hover:bg-transparent"
                  )}
                  variant="outline"
                  onClick={() => {
                    setSelected("1 month");
                    get1Month();
                    // selectDateFromChange("");
                    // selectDateToChange("");
                  }}
                >
                  1 month
                </Button>
                <Button
                  type="button"
                  className={cn(
                    "rounded-3xl text-xs h-6 p-[10px]",
                    selected === "6 months"
                      ? "bg-primary-0 hover:bg-primary-0 border-0"
                      : "bg-transparent hover:bg-transparent"
                  )}
                  variant="outline"
                  onClick={() => {
                    setSelected("6 months");
                    get6Month();
                    // selectDateFromChange("");
                    // selectDateToChange("");
                  }}
                >
                  6 months
                </Button>
                <Button
                  type="button"
                  className={cn(
                    "rounded-3xl text-xs h-6 p-[10px]",
                    selected === "1 year"
                      ? "bg-primary-0 hover:bg-primary-0 border-0"
                      : "bg-transparent hover:bg-transparent"
                  )}
                  variant="outline"
                  onClick={() => {
                    setSelected("1 year");
                    get1Year();
                    // selectDateFromChange("");
                    // selectDateToChange("");
                  }}
                >
                  1 year
                </Button>
              </div>
            </div>

            <Separator orientation="horizontal" className="h-[1px] " />
          </>
        }
        <div className="flex items-center gap-2 w-full ">
          <div className="flex flex-col gap-2 w-full">
            <Label htmlFor="link" className="text-xs">
              Start date
            </Label>
            <CustomDatePicker
              date={dateFrom}
              setDate={(e: any) => {
                setDateFromFormat(formatType(e));
                setDateFrom(e);
              }}
            />
          </div>
          <div className="flex items-center justify-center mt-6">
            <Separator orientation="horizontal" className="h-[1px] w-2" />
          </div>
          <div className="flex flex-col gap-2 w-full">
            <Label htmlFor="link" className="text-xs">
              End date
            </Label>
            <CustomDatePicker
              date={dateTo}
              setDate={(e: any) => {
                setDateToFormat(formatType(e));
                setDateTo(e);
              }}
            />
          </div>
        </div>
        {!location?.includes('transactions') &&
          <div className="w-full gap-1">
            <Label className="text-[11px]">Status</Label>
            <Select
              onValueChange={e => setStatus(e === 'all' ? "" : e)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All</SelectItem>
                <SelectItem value="active">Active Users</SelectItem>
                <SelectItem value="inactive">Inactive Users</SelectItem>
                <SelectItem value="true">Email Verified</SelectItem>
                <SelectItem value="false">Email Unverified</SelectItem>
                <SelectItem value="verified">KYC Verified</SelectItem>
                <SelectItem value="unverified">KYC Unverified</SelectItem>
              </SelectContent>
            </Select>
          </div>
        }


      </div>
      <DialogFooter className="px-5 py-3 border-t-[1px] flex flex-row sm:justify-between items-center">
        <Button
          type="button"
          className="bg-off-white text-primary0 h-8 rounded-[10px] p-[8px 12px] hover::bg-off-white"
          onClick={() => {
            setDateFromFormat("");
            setDateToFormat("");
            setDateTo(undefined);
            setDateFrom(undefined);
            setSelected("");
            setIsOpen(false)
          }}
        >
          Cancel
        </Button>

        <Button
          type="button"
          className="bg-gradient-to-r from-primary to-primary-2 h-8 rounded-[10px] p-[8px 12px]"
          onClick={download}
          disabled={downloadLoading}
        >
          {downloadLoading && <Loader2 className="animate-spin" />}

          Export
        </Button>
      </DialogFooter>
    </CustomModal>
  );
};

export default ExportFilterAction;
